import { Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { Globals } from '../../../globals';
import { CategoryItem, CategoryData } from '../../../models/categorySidebar.interface';

@Component({
  selector: 'app-category-sidebar',
  templateUrl: './category-sidebar.component.html',
  standalone: false,
})
export class CategorySidebarComponent implements OnInit {
  @Input() categoryData: CategoryData | null = null;
  @Input() isResponsiveScreen = false;
  @Input() isToggled = false;
  @Input() selectedCategory = '';
  @Input() sidebarShow = false;

  @Output() categorySelected = new EventEmitter<CategoryItem>();

  constructor(public globals: Globals) {}

  ngOnInit() {
    if (this.categoryData && this.categoryData.children) {
      this.initializeExpandedStates(this.categoryData.children);
    }
  }

  initializeExpandedStates(items: CategoryItem[]): void {
    items.forEach((item) => {
      if (item.children) {
        item.expanded = false;
        this.initializeExpandedStates(item.children);
      }
    });
  }

  toggle(item: CategoryItem, event: Event): void {
    event.stopPropagation();
    if (item.children) {
      item.expanded = !item.expanded;
    }
  }

  onSelectCategory(item: CategoryItem, event: Event): void {
    this.selectedCategory = item.title;
    event.stopPropagation();
    this.categorySelected.emit(item);
  }

  isSelected(item: CategoryItem): boolean {
    return this.selectedCategory === item.title;
  }
}
